import { useDevice } from 'components/DeviceContext.js';

function Rodape() {
  const { isMobile } = useDevice();

  return (
    <footer
      style={{
        width: '100%',
        backgroundColor: 'var(--azul-escuro)',
        color: 'var(--branco)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: isMobile ? '10px 12px' : '12px 20px',
        fontSize: isMobile ? '14px' : '14px',
        lineHeight: '1.4',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          textAlign: 'center',
        }}
      >
        © 2024 Confederação Nacional de Municípios. Todos os direitos
        reservados. Todo o conteúdo produzido pode ser reproduzido, desde que
        citada a fonte.
      </div>
    </footer>
  );
}

export default Rodape;